'use client';

import React, { useState } from 'react';
import { ServiceFaq } from '@/lib/seo/services';

/**
 * Accessible FAQ accordion. The matching FAQPage JSON-LD is rendered separately
 * on the server (see the service route) so it is always crawlable.
 */
export default function ServiceFAQ({ faqs }: { faqs: ServiceFaq[] }) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="max-w-3xl mx-auto divide-y divide-white/[0.08] rounded-2xl border border-white/[0.08] bg-[#13151F]/60">
      {faqs.map((faq, i) => {
        const isOpen = open === i;
        return (
          <div key={i}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="w-full flex items-center justify-between gap-4 text-left px-6 py-5 hover:bg-white/[0.02] transition-colors"
            >
              <span className="text-base font-semibold text-white">{faq.q}</span>
              <svg
                className={`w-5 h-5 flex-shrink-0 text-purple-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <div
              className="grid transition-all duration-200 ease-out"
              style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
            >
              <div className="overflow-hidden">
                <p className="px-6 pb-5 text-gray-400 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
